import { ReactElement } from 'react';

import { Navigate, Outlet, useLocation } from 'react-router-dom';

import { ROUTE } from '@/constants/route';

interface RequireWizardStateProps {
  children?: ReactElement;
}

const RequireWizardState: React.FC<RequireWizardStateProps> = ({ children }) => {
  const { state } = useLocation();

  if (state === null || typeof state !== 'object') {
    return <Navigate to={ROUTE.SELECTOPERATION} replace />;
  }

  return children ?? <Outlet />;
};

export default RequireWizardState;
